/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthDocumentSelectionChange } from './PalReauthDocumentSelectionChange';
import {
    PalReauthDocumentSelectionChangeFromJSON,
    PalReauthDocumentSelectionChangeFromJSONTyped,
    PalReauthDocumentSelectionChangeToJSON,
    PalReauthDocumentSelectionChangeToJSONTyped,
} from './PalReauthDocumentSelectionChange';

/**
 * 
 * @export
 * @interface UpdatePalReauthDocumentSelections200ResponseData
 */
export interface UpdatePalReauthDocumentSelections200ResponseData {
    /**
     * 
     */
    selections: Array<PalReauthDocumentSelectionChange>;
}

/**
 * Check if a given object implements the UpdatePalReauthDocumentSelections200ResponseData interface.
 */
export function instanceOfUpdatePalReauthDocumentSelections200ResponseData(value: object): value is UpdatePalReauthDocumentSelections200ResponseData {
    if (!('selections' in value) || value['selections'] === undefined) return false;
    return true;
}

export function UpdatePalReauthDocumentSelections200ResponseDataFromJSON(json: any): UpdatePalReauthDocumentSelections200ResponseData {
    return UpdatePalReauthDocumentSelections200ResponseDataFromJSONTyped(json, false);
}

export function UpdatePalReauthDocumentSelections200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthDocumentSelections200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'selections': ((json['selections'] as Array<any>).map(PalReauthDocumentSelectionChangeFromJSON)),
    };
}

export function UpdatePalReauthDocumentSelections200ResponseDataToJSON(json: any): UpdatePalReauthDocumentSelections200ResponseData {
    return UpdatePalReauthDocumentSelections200ResponseDataToJSONTyped(json, false);
}

export function UpdatePalReauthDocumentSelections200ResponseDataToJSONTyped(value?: UpdatePalReauthDocumentSelections200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selections': ((value['selections'] as Array<any>).map(PalReauthDocumentSelectionChangeToJSON)),
    };
}

